// src/components/Reports/Summaries/SecuritySummary.js
import React from 'react';
import { Row, Col } from 'react-bootstrap';

const SecuritySummary = ({ summary }) => {
    return (
        <Row>
            <Col lg={3} md={6} className="mb-3">
                <div className="p-3 bg-light rounded text-center">
                    <h6 className="text-muted mb-2">Celkem problémů</h6>
                    <div className="fs-3 fw-bold text-primary">{summary.totalIssues}</div>
                </div>
            </Col>
            <Col lg={3} md={6} className="mb-3">
                <div className="p-3 bg-light rounded text-center">
                    <h6 className="text-muted mb-2">Kritické problémy</h6>
                    <div className="fs-3 fw-bold text-danger">{summary.criticalIssues}</div>
                </div>
            </Col>
            <Col lg={3} md={6} className="mb-3">
                <div className="p-3 bg-light rounded text-center">
                    <h6 className="text-muted mb-2">Střední problémy</h6>
                    <div className="fs-3 fw-bold text-warning">{summary.mediumIssues}</div>
                </div>
            </Col>
            <Col lg={3} md={6} className="mb-3">
                <div className="p-3 bg-light rounded text-center">
                    <h6 className="text-muted mb-2">Nízké problémy</h6>
                    <div className="fs-3 fw-bold text-info">{summary.lowIssues}</div>
                </div>
            </Col>
        </Row>
    );
};

export default SecuritySummary;